import {Table} from 'antd';
import {ColumnsType} from 'antd/es/table';
import {t} from 'i18next';
import {defaultTablePagination, pageSizeConstant} from '@/constants';
import {FormatDateEnum, LogsItem} from '@/models';
import {formatDate, getObjectDetails} from '@/utils';
import LogsWrapper from '../logs';

export interface ICommonLogsProps {
  isLoading: boolean;
  onOpen: () => void;
  data: LogsItem[];
  mainFieldName: string;
  mainFieldTitle: string;
}

const CommonLogs = ({
                      isLoading,
                      onOpen,
                      data,
                      mainFieldName,
                      mainFieldTitle,
                    }: ICommonLogsProps) => {
  const logsColumns: ColumnsType<LogsItem> = [
    {
      title: '#',
      dataIndex: 'key',
      key: 'key',
      render: (_text, _record, index) => index + 1,
    },
    {
      title: mainFieldTitle,
      dataIndex: 'descriptiveData',
      key: 'name',
      render: (descriptiveData: Record<string, any>) =>
        descriptiveData[mainFieldName],
    },
    {
      title: t('actions'),
      dataIndex: 'type',
      key: 'action',
    },
    {
      title: t('from'),
      dataIndex: 'from',
      key: 'from',
      render: from => <p className='new-line'>{getObjectDetails(from)}</p>,
    },
    {
      title: t('to'),
      dataIndex: 'to',
      key: 'to',
      render: text => <p className='new-line'>{getObjectDetails(text)}</p>,
    },
    {
      title: t('description'),
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: t('userType'),
      dataIndex: 'editedBy',
      key: 'user',
    },
    {
      title: t('dateAndTime'),
      dataIndex: 'timestamp',
      key: 'date',
      render: date => formatDate(date, FormatDateEnum.YMDHMA),
    },
  ];

  return (
    <LogsWrapper onOpen={onOpen}>
      <Table
        loading={isLoading}
        rowKey='objectID'
        columns={logsColumns}
        dataSource={data}
        pagination={{
          pageSize: pageSizeConstant,
          total: data?.length || 0,
          ...defaultTablePagination,
        }}
        scroll={{x: true}}
      />
    </LogsWrapper>
  );
};

export default CommonLogs;
